import { BlockUI, NgBlockUI } from 'ng-block-ui';
import {
  ChangeDetectorRef,
  Component,
  Input,
  OnInit
}                           from '@angular/core';
import { NgbActiveModal }   from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

import { ApiService }        from '../api/api.service';
import { BigDecimalService } from '../core/services/big-decimal.service';
import { CodeTypeModel }     from '../core/models/code-type';
import { DateParserService } from '../core/services/date-parser.service';
import { FlipperSidesModel } from '../shared/components/flipper/typings/flipper.sides';
import { MessagesService }   from '../messages/messages.service';
import { RecpatchaService }  from '../recaptcha/recaptcha.service';

@Component({
  selector   : 'wor-reactivate-subscription',
  template: require('./subscription.reactivate.component.html')
})
export class ReactivateSubscriptionComponent implements OnInit {
  activeSide   : FlipperSidesModel = 'front';
  balance      : string;
  countries    : Array<CodeTypeModel> = [];
  failedRetry  = false;
  months       : Array<number> = [];
  states       : Array<CodeTypeModel> = [];
  subscription = {} as any;
  years        : Array<number> = [];

  @BlockUI('pastDueBackBlock') backBlock   : NgBlockUI;
  @BlockUI('pastDueFrontBlock') frontBlock : NgBlockUI;

  @Input() balanceInCents : number;

  constructor (
    public activeModal         : NgbActiveModal,
    private apiService         : ApiService,
    private bigDecimalService  : BigDecimalService,
    private changeDetectorRef  : ChangeDetectorRef,
    private dateParserService  : DateParserService,
    private messagesService    : MessagesService,
    private recaptchaService   : RecpatchaService,
    private translateService   : TranslateService
  ) {}

  ngOnInit () : void {


    this.init();


  }

  changeSide ( side : FlipperSidesModel = 'back' ) : void {
    this.activeSide = side;

    this.changeDetectorRef.detectChanges();

    if (this.backBlock.isActive) {


      this.backBlock.stop();


    }

    if (this.frontBlock.isActive) {


      this.frontBlock.stop();


      };


    }

  enterNewCard () : void {


    this.changeSide();


  }

  getBalance ( balanceInCents : number ) : string {


    const balance = this.bigDecimalService.get(balanceInCents);


    return balance.movePointLeft(2).toString();


  }

  getCountries () : void {
    this.apiService.get('/system/country_types', null, 'countries', {
      bypass: true
    })
    .then(( countries : Array<CodeTypeModel> ) => {
      this.countries = countries;

      if (this.subscription.billing_country) {


        this.getStates();


      }
    });
  }

  getStates ( country : string = this.subscription.billing_country ) : void {
    this.subscription.billing_state = undefined;

    this.apiService.get('/system/states_for_country', country, null, {
      bypass: true
    })
    .then(( states : Array<CodeTypeModel> ) => {
      this.states = states;
    });
  }

  init () : void {


    this.months  = this.dateParserService.getMonths();
    this.years   = this.dateParserService.years();
    this.balance = this.getBalance(this.balanceInCents);

    this.getCountries();


  }

  retryCurrentCard () : void {
    this.frontBlock.start();

    this.recaptchaService.verifyUser()
    .then(() => this.apiService.post('/chargify/retry_subscription', this.subscription, 'subscription'))
    .then(( result ) => {
      if ( result.code == '422' ) {

        this.failedRetry = true;

        this.changeSide();

        this.messagesService.show(this.translateService.instant('COMPANY_SPACE.RETRY_FAILED_NEW_CARD'), 'error');

      }
      else {
        this.messagesService.show(this.translateService.instant('COMPANY_SPACE.RETRY_SUCCESSFUL_LOGGING_IN'), 'success');

        this.activeModal.close(true);
      }
    })
    .catch(( err ) => {
      this.messagesService.error(err);
    })
    .finally(() => {
      this.frontBlock.stop();
    });
  }

  retryWithNewCard () : void {
    this.backBlock.start();

    this.recaptchaService.verifyUser()
    .then(() => this.apiService.post('/chargify/update_payment', this.subscription, 'subscription'))
    .then(( subscription ) => this.apiService.post('/chargify/retry_subscription', this.subscription, 'subscription'))
    .then(( result ) => {
      if ( result.code == '422' ) {

        this.failedRetry = true;

        this.changeSide('front');

        this.messagesService.show(this.translateService.instant('COMPANY_SPACE.NEW_CARD_FAILED'), 'error');

      }
      else {
        this.messagesService.show(this.translateService.instant('COMPANY_SPACE.RESUBMISSION_SUCCESSFUL'), 'success');

        this.activeModal.close(true);
      }
    })
    .catch(( err ) => {
      this.messagesService.error(err);
    })
    .finally(() => {
      this.backBlock.stop();
    });
  }
}